var Reverb = window.Reverb || {};

Reverb.Address = (function () {
  function init() {
    bindCountrySelectProgressiveDisclosure();
    changeRegionDropDownOnCountryChange();
  }

  function bindCountrySelectProgressiveDisclosure() {
    $(document).on('click', 'a[data-bind=\'change-country\']', function (e) {
      e.preventDefault();
      $(this).hide();
      $(this).siblings('[data-bind=\'hide-with-change-country\']').hide();
      $(this).siblings('[data-bind=\'change-country-select\']').fadeIn();
    });
  }

  function changeRegionDropDownOnCountryChange() {
    $(document).on('change', 'select[data-bind=\'country-select\']', function () {
      var country_select = $(this);
      var address_fields = $(this).closest('[data-address-fields]');
      var select_wrapper = address_fields.find('[data-state-wrapper]');
      var region_select = select_wrapper.find('select');

      var country_code = country_select.val();
      var field_prefix = country_select.data('field-prefix');
      var field_name = country_select.data('region-field-name');
      var region_required = $(select_wrapper).data('region-required');
      var shipping_estimate_field = region_select.data('shipping-estimate-field');

      // The params specified here are passed into the controller so that when
      // it re-renders the partial via ajax, all its original params are retained.
      var url = '/addresses/subregion_options?' + $.param({
        parent_region: country_code,
        field_prefix: field_prefix,
        field_name: field_name,
        region_required: region_required,
        shipping_estimate_field: shipping_estimate_field
      });

      $('select', select_wrapper).attr('disabled', true);
      $.get(url, function (data) {
        select_wrapper.replaceWith(data);
        country_select.trigger('regions_updated');
      });
    });
  }

  return {
    init: init
  };
})();

$(function () {
  Reverb.Address.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/address.js